import React, { useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap'
import Floatingbutton from './Floatingbutton'
import PageHeader from '../Elements/UI/PageHeader'
import EmptyState from '../Elements/UI/EmptyState'
import FeedSkeleton from '../Elements/UI/FeedSkeleton'
import FeedTime from '../Elements/UI/FeedTime'
import DeleteButton from '../Elements/UI/DeleteButton'
import Conformationdeleteform from '../Modals/Conformationdeleteform'
import { connect } from 'react-redux'
import FormBuilder from '../Elements/FormBuilder'
import '../Elements/FormBuilder.css'
import Openformmodal from '../Modals/Openformmodal'
import config from '../../config'
import axios from 'axios'
import { toast } from 'react-toastify'
import FormRenderCard from './SmallComponents/FormRenderCard'

function FormsPage({ userAccess = [] }) {
  const wideBlockRef = useRef()

  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)
  const [showModal, setShowModal] = React.useState(false)
  const [selectId, setSelectId] = React.useState(null)
  const [inputData, setInputData] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [formItems, setformItems] = React.useState([])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  useEffect(() => {
    getforms().finally(() => setLoading(false))
  }, [])

// const handleFormSave = formJSON => {
//     setformItems(prev => [
//       {
//         id: Date.now(),
//         ...formJSON
//       },
//       ...prev
//     ])

//   }

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const getforms = async () => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.get(`${config.apiUrl}/post/getAll/Form`, {
        headers: { Authorization: token }
      })
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data.data || []).map(form => {
        const data = form.Data || {}
        return {
          CreatedOn: form.CreatedOn || form.createdAt || form.CreatedAt || null,
          postId: form.ID,
          formId: data.FormID,         
          id: data.FormID,
          title: data.title || '',
          description: data.description || '',
          submitButtonText: data.submittext || 'Submit',
          fields: (data.fields || []).map((field, index) => ({
            id: field.id,
            type: field.type,
            label: field.label,
            placeholder: field.placeholder,
            required: field.required,
            options: field.options || []
          })),
          ...form
        }
      })
      normalized.sort((a, b) => b.postId - a.postId)
      setformItems(normalized)
      console.log('Data', {normalized})
    } catch (err) {
      console.error(err)
    }
  }

  const handleConfirmDelete = async () => {
  if (!deleteId) return;

  const token = localStorage.getItem('token');

  try {
    await axios.delete(`${config.apiUrl}/post/${deleteId}`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    });

    setformItems(prev =>
      prev.filter(item => item.postId !== deleteId)
    );

    toast.success('Form deleted successfully!');
    setShowConfirmModal(false);
    setDeleteId(null);
  } catch (e) {
    console.error(e);
    toast.error('Failed to delete poll');
  }
};

  

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
    console.log('Floating clicked')
  }

  const handleDeleteModal = postId => {
  setDeleteId(postId)           
  setShowConfirmModal(true)
}

  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100 // adjust this based on your header or spacing
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }
    updateHeight()
    window.addEventListener('resize', updateHeight)

    return () => window.removeEventListener('resize', updateHeight)
  }, [])
  const canDelete = Array.isArray(userAccess) && userAccess.includes('DeleteForm')

  return (
    <div id="appCapsule">
      <div className="section full mt-1">

        <div className="wide-block mt-1" ref={wideBlockRef}>
          <PageHeader title="Forms" subtitle="Requests and submissions" />

          {loading && <FeedSkeleton label="Loading forms" />}

          {!loading && (!Array.isArray(formItems) || formItems.length === 0) && (
            <EmptyState icon="create-outline" title="No forms yet" text="New items will appear here once they are posted." />
          )}

          <div className="timeline timed">
            {formItems.map(item => (
              <div className="item" key={item.id}>
                <FeedTime value={item.CreatedOn} />
                <div className="dot bg-info" aria-hidden="true"></div>
                <div className="content">
                  <article className={`card bl-feed-card${canDelete ? ' has-action' : ''}`}>
                    {canDelete && (
                      <DeleteButton onClick={() => handleDeleteModal(item.postId)} label="Delete form" />
                    )}
                    <FormRenderCard item={item} reloadList={getforms} />
                  </article>
                </div>
              </div>
            ))}
          </div>
        </div>
        {userAccess.includes('CreateForm') && (
          <Floatingbutton onOpen={handlemodalOpen} />
        )}

        <Openformmodal
          show={showModal}
          userId={selectId}
          onClose={() => setShowModal(false)}
          inputData={inputData}
          // onSave={handleFormSave}
          getforms={getforms}
        />

        <Conformationdeleteform
            show={showConfirmModal}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
        />
      </div>
    </div>
  )
}
const mapStateToProps = ({ auth }) => {
  const { userAccess } = auth
  return {
    userAccess
  }
}
const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(FormsPage)
